import { type QueryKey, type UseQueryOptions, useQuery as useQueryReact } from '@tanstack/react-query';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services/api';

export const useQuery = <
  TQueryFunctionData,
  TError = ApiClientResponseError<ResponseErrorDataObject>,
  TData = TQueryFunctionData,
  TQueryKey extends QueryKey = QueryKey,
>(
  options: UseQueryOptions<TQueryFunctionData, TError, TData, TQueryKey>,
) =>
  useQueryReact<TQueryFunctionData, TError, TData, TQueryKey>({
    gcTime: 24 * 60 * 60 * 1000, // 1 Day
    staleTime: 5 * 60 * 1000, // 5 Minutes
    ...options,
  });

export { type UseQueryOptions } from '@tanstack/react-query';
